import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onedayschoolspotpunewithinpune() {



    const cardData =
    {
        keyword: 'One Day School Picnic Spot Near Pune Within 100 Kms',
        heading: 'Anand Krushi Paryatan Kendra: One Day School Picnic Spot Near Pune Within 100 Kms',
        headingDescription: 'If you are searching for a one day school picnic spot near Pune within 100 kms, Anand Krushi Paryatan Kendra in Morachi Chincholi is a top choice. Located just 55 km from Pune, this 40-acre agri-tourism destination offers a safe, fun-filled, and educational experience for students of all age groups. The center features a wide range of engaging rural activities like bullock cart and tractor rides, horse riding, boating, swimming, and rain dance. Children also enjoy traditional games, magic shows, and puppet performances that enhance cultural understanding and group participation. Surrounded by nature and thoughtfully designed for school groups, Anand Krushi Paryatan Kendra provides an ideal mix of learning and leisure—making it a highly recommended school picnic destination within a short drive from Pune.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
"topPlaces": [
  {
    "title": "Peacock Spotting & Nature Trails",
    "description": "Start the picnic with guided nature walks through farmlands, ponds, and orchards. Students often spot free-roaming peacocks, parakeets, and bulbuls—great for early-morning adventures and nature photography."
  },
  {
    "title": "Bullock Cart & Tractor Rides",
    "description": "Take students on fun, bumpy rides across village tracks in decorated bullock carts and farm tractors. This rural experience is both entertaining and educational, offering insight into village transport heritage."
  },
  {
    "title": "Traditional Village Games",
    "description": "Organise group games like kho-kho, kabaddi, lagori, sack race, and gilli-danda on open playgrounds. These energy-packed activities promote teamwork, physical fitness, and joyful interaction among students."
  },
  {
    "title": "Interactive Farm Learning",
    "description": "Teachers can lead hands-on stations where students plant seeds, water saplings, create compost pits, and learn about seasonal crops and organic farming—all guided by local farmers."
  },
  {
    "title": "Animal Feeding & Dairy Visit",
    "description": "Visit the farm’s dairy section where students can feed calves, milking demonstration sessions, and observe goats and ducks—a wonderful way to learn about farm animals and their care."
  },
  {
    "title": "Craft & Diya-Painting Workshops",
    "description": "Set up creative corners for clay pottery, diya painting, and leaf-print crafts. These activity sessions help students explore their artistic side and take home handmade souvenirs."
  },
  {
    "title": "Nutritious Rural Meals",
    "description": "Serve wholesome Maharashtrian-style meals—breakfast (poha, upma), unlimited thali lunch on banana leaves, and evening snacks. Meals are cooked fresh, healthy, and kid-friendly."
  },
  {
    "title": "Rain Dance & Splash Zone",
    "description": "Cool off after afternoon sessions with fun rain dance and splash pool time. DJ-backed music and safe pool areas make this a favorite for summer trips and enthusiastic kids."
  },
  {
    "title": "Puppet/Magic Show & Cultural Fun",
    "description": "Students enjoy engaging puppet shows, magic acts, or folk storytelling sessions in a shaded outdoor space—combining laughter, culture, and entertainment."
  },
  {
    "title": "Group Photo Spots & Return Gifts",
    "description": "End the day with a group photo under iconic village backdrops—like bullock carts or peacock trails. Students also receive small take-home tokens like clay tokens or seed packets."
  }
],




"services": [
  {
    "name": "Best School-Friendly Spot in Morachi Chincholi",
    "description": "Located within 60 km from Pune, this peaceful and secure location is ideal for school excursions. With dedicated zones for students, managed group entry, and staff trained in student safety, it's a trusted choice for teachers planning safe and enriching one-day trips."
  },
  {
    "name": "Farm-Based Education Trip",
    "description": "Students are guided through a working farm to learn firsthand about soil care, irrigation techniques, seasonal crops, and eco-farming practices. It's an immersive experience that blends classroom learning with practical exposure in a scenic outdoor environment."
  },
  {
    "name": "Safe Playgrounds for Students",
    "description": "Custom-built play zones with age-appropriate equipment such as rope bridges, slides, climbing walls, and merry-go-rounds ensure fun and safe recreation. Trained staff supervise all playtime to prevent injury and encourage team interaction."
  },
  {
    "name": "Fun Animal Interaction Zones",
    "description": "Children can feed and interact with friendly farm animals like rabbits, goats, hens, and ducks—under the watchful eye of caretakers. These interactions teach empathy, responsibility, and basic animal care in a supervised farm setting."
  },
  {
    "name": "Interactive Farming Demos",
    "description": "Kids actively participate in activities such as sowing seeds, watering plants, harvesting vegetables, and making compost. These demos instill respect for farming labor and deepen understanding of sustainable food systems."
  },
  {
    "name": "Cultural Exposure for Kids",
    "description": "Through vibrant Maharashtrian folk dance, music performances, and local storytelling traditions, students explore rural culture in a hands-on way. Craft corners and folk-art demos add to the cultural richness of the visit."
  },
  {
    "name": "Group Lunch Zones",
    "description": "Ample shaded dining spaces with long benches offer a clean, organized meal environment. Students are served traditional Maharashtrian vegetarian meals cooked fresh with farm-grown ingredients—nourishing and kid-approved."
  },
  {
    "name": "Clean Toilets and Hygiene Maintained",
    "description": "Multiple washroom blocks with constant water supply, hand sanitizing stations, and cleaning staff ensure student hygiene is top-notch. Safety protocols are strictly followed throughout the day."
  },
  {
    "name": "Games and Nature Activities for Children",
    "description": "Engage students in thoughtfully designed outdoor games like treasure hunts, nature bingo, obstacle races, and relay events that develop teamwork, observation, and physical fitness—all in a fresh-air environment."
  },
  {
    "name": "Learning via Nature Sessions",
    "description": "Under open skies and shady trees, students attend interactive mini-lectures on local plant species, types of soil, insect life, and the importance of biodiversity. Each session ties back to their school curriculum with practical links."
  },
  {
    "name": "On-Site Guides and Support Staff",
    "description": "Trained facilitators and volunteers ensure a smooth experience by maintaining small student-to-guide ratios. They assist in transitions between sessions, enforce safety rules, and lead interactive learning with enthusiasm."
  },
  {
    "name": "Special School Packages Available",
    "description": "Tailor-made school group packages include activity scheduling, guided sessions, snacks, lunch, transportation help, and group photo moments—all within school budgets. Options available for various age groups and group sizes."
  },
  {
    "name": "Booking and Travel Help",
    "description": "Our team supports schools through the entire planning process—online booking, bus vendor coordination, permission letter formats, parent updates, and on-site group assistance for a smooth and stress-free trip."
  },
  {
    "name": "Relaxing and Fun Environment for Students",
    "description": "With large shady trees, scenic farm fields, water bodies, and open spaces to relax between sessions, students enjoy both mental stimulation and moments of calm during their visit—ideal for mindfulness and recovery."
  },
  {
    "name": "Age‑Appropriate Games and Shows",
    "description": "From puppet shows and folk tales for younger students to fun adventure-based challenges for older kids, every session is tailored to suit energy levels and learning capabilities of different age brackets."
  },
  {
    "name": "Bird-Watching and Bullock Cart Rides for Students",
    "description": "Guided birding trails let students spot native species and understand their habitats, while traditional bullock cart rides take them on a tour through the rustic countryside—blending fun, eco-awareness, and cultural education in one memorable ride."
  }
],
"tableData": [
  ["Best School-Friendly Spot in Morachi Chincholi", "Farm-Based Education Trip"],
  ["Safe Playgrounds for Students", "Fun Animal Interaction Zones"],
  ["Interactive Farming Demos", "Cultural Exposure for Kids"],
  ["Group Lunch Zones", "Clean Toilets and Hygiene Maintained"],
  ["Games and Nature Activities for Children", "Learning via Nature Sessions"],
  ["On-Site Guides and Support Staff", "Special School Packages Available"],
  ["Booking and Travel Help", "Relaxing and Fun Environment for Students"],
  ["Age‑Appropriate Games and Shows", "Bird-Watching and Bullock Cart Rides for Students"]
],



"whychoose": [
  {
    "WhyChooseheading": "One-Day School Picnic Within 100 Kms of Pune",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra is an ideal school picnic spot located within 100 kilometers of Pune, offering a convenient and enriching escape for students and teachers alike."
  },
  {
    "WhyChooseheading": "Educational and Nature-Focused Activities",
    "WhyChoosedescription": "Students can engage in nature walks, farming demos, and eco-learning sessions that combine education with hands-on rural experiences."
  },
  {
    "WhyChooseheading": "Exciting Outdoor Adventures for Students",
    "WhyChoosedescription": "From tractor rides to rope activities and zip-lining, the center offers thrilling yet safe adventures that promote physical activity and teamwork."
  },
  {
    "WhyChooseheading": "Farm-Fresh Maharashtrian Meals",
    "WhyChoosedescription": "Delicious vegetarian meals prepared using organic, farm-grown produce introduce students to local cuisine and healthy eating habits."
  },
  {
    "WhyChooseheading": "Peaceful, Pollution-Free Campus",
    "WhyChoosedescription": "The center’s clean, green environment far from city noise allows students to relax, breathe fresh air, and connect with nature."
  },
  {
    "WhyChooseheading": "Short Travel Time from Pune",
    "WhyChoosedescription": "Being just under 100 km from Pune, Anand Krushi Paryatan Kendra is perfect for day trips, minimizing travel fatigue while maximizing fun and learning."
  }
]
































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Why is Anand Krushi Paryatan Kendra a good one day school picnic spot near Pune within 100 kms?',
    answer: 'Located just around 60-70 km from Pune, Anand Krushi Paryatan Kendra offers a perfect blend of nature, learning, and rural adventure. It’s easily accessible and provides a full-day experience packed with safe and engaging activities for students.',
  },
  {
    id: 'FAQ2',
    question: 'What kind of activities can students enjoy here?',
    answer: 'Students can enjoy bullock cart and tractor rides, a refreshing rain dance, swimming, farm visits, nature trails, and traditional village games that offer fun and education together.',
  },
  {
    id: 'FAQ3',
    question: 'Is food included in the school picnic package?',
    answer: 'Yes, the package includes hygienic and tasty Maharashtrian vegetarian meals including breakfast, lunch, and evening snacks made from fresh, local ingredients.',
  },
  {
    id: 'FAQ4',
    question: 'How safe is Anand Krushi Paryatan Kendra for school children?',
    answer: 'The place prioritizes safety with trained staff, medical aid availability, secure play areas, and continuous supervision for students.',
  },
  {
    id: 'FAQ5',
    question: 'What is the distance from Pune and how long does it take to reach?',
    answer: 'Anand Krushi Paryatan Kendra is about 60-70 km from Pune and Pimpri-Chinchwad and takes roughly 1.5 to 2 hours by bus or car, making it ideal for one-day trips.',
  },
  {
    id: 'FAQ6',
    question: 'Are there enough facilities for large school groups?',
    answer: 'Yes, the facility is equipped to handle large school groups with spacious grounds, ample seating, clean washrooms, and organized activity zones.',
  },
  {
    id: 'FAQ7',
    question: 'What is the duration of the school picnic?',
    answer: 'Typically, a one-day picnic runs from around 9:30 AM to 5:30 PM, covering all activities, meals, and rest breaks.',
  },
  {
    id: 'FAQ8',
    question: 'Are there shaded areas and resting spots available?',
    answer: 'Yes, there are shaded seating areas, rest shelters, and clean toilets to ensure the comfort of students and staff throughout the visit.',
  },
  {
    id: 'FAQ9',
    question: 'Is advance booking required?',
    answer: 'Yes, advance booking (at least 2-3 weeks prior) is recommended, especially during weekends and the school outing season, to ensure availability.',
  },
  {
    id: 'FAQ10',
    question: 'Can the picnic organizers help with transport arrangements?',
    answer: 'Yes, Anand Krushi Paryatan Kendra can assist schools in arranging reliable transport services like buses, if needed.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Sunita Joshi, School Teacher, Pune',
    feedback: "Being just under 100 km from Pune, Anand Krushi Paryatan Kendra was perfect for our school trip. The kids had fun and we felt very safe throughout the visit.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Sandeep Patil, Principal, PCMC',
    feedback: "Ideal for one-day picnics near Pune! Clean environment, good food, fun-filled activities – and it’s all within comfortable traveling distance. Highly recommend for school groups.",
    rating: 5,
  },
];





































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];
const schoolPicnic100KmSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOccupationalProgram",
  "name": "One Day School Picnic Spot Near Pune Within 100 Kms",
  "description": "Explore Anand Krushi Paryatan Kendra – a top-rated one-day school picnic destination within 100 km from Pune offering guided farm tours, nature trails, rural games, and cultural education in a safe environment.",
  "educationalProgramMode": "OnSite",
  "provider": {
    "@type": "Organization",
    "name": "Anand Krushi Paryatan Kendra",
    "url": "https://morachichincholi.in/"
  },
  "hasCourse": [
    {
      "@type": "Course",
      "name": "Agro-Tourism Experience",
      "description": "Hands-on farming, bullock cart rides, and interaction with nature."
    },
    {
      "@type": "Course",
      "name": "Eco-Education & Adventure",
      "description": "Bird watching, wildlife exposure, and cultural learning activities."
    }
  ],
  "url": "https://morachichincholi.in/one-day-school-picnic-100-kms"
};





    return (
        <div>
<Helmet>
  <title>One Day School Picnic Spot Near Pune Within 100 Kms | Agro & Nature Education</title>
  <meta 
    name="description" 
    content="Find the best one day school picnic spot near Pune within 100 kms. Anand Krushi Paryatan Kendra offers safe and educational farm experiences, nature trails, rural games, wildlife visits, and cultural learning for school groups." 
  />
  <meta 
    name="keywords" 
    content="Top school picnic spots within 100 km from Pune, Nature and farm tours near Pune, Safe travel distance picnic places, One-day educational tours under 100 kms, School trip with lunch and activities, Cultural day trip spots near Pune, Affordable group picnic destinations, Close-to-nature school experiences, Wildlife & bird sanctuary visits, Agro-tourism near Pune for students, Historical spots within 100 kms, Guided nature walk spots, Eco-learning destinations for schools, Adventure parks near Pune under 100 kms, Farm games and rural education tours" 
  />
  <script type="application/ld+json">
    {JSON.stringify(schoolPicnic100KmSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onedayschoolspotpunewithinpune;